/**
 * Wherever this is imported, please ensure to have the Snackbar component as well.
 * As we are sending saved message from here.
 */
import axios from 'axios'
import {useCategoriesStore,} from '@/stores/CategoriesStore'
import {useGroupsStore,} from '@/stores/GroupsStore'
import {useUsersStore,} from '@/stores/UsersStore'
import {useRulesStore,} from '@/stores/RulesStore'
import {useConnectionsStore,} from '@/stores/ConnectionsStore'
import {debounce, findIndex, isArray, isEqual, isObject, size,} from 'lodash'
import Snackbar from '@/components/Snackbar'
import MixinGenericLocalStorage from '@/mixins/MixinGenericLocalStorage'
import {useProgressBarsStore,} from '@/stores/ProgressBarStore'
import {mapState, mapWritableState,} from 'pinia'
import MixinGenericHelper from '@/mixins/generic/MixinGenericHelper'
import {useAdminOptionsStore,} from '@/stores/AdminOptionsStore'
import {useIdefix3AdditionalFields,} from '@/stores/Idefix3AdditionalFieldsStore'
import MixinConfigCategories from '@/mixins/database/MixinConfigCategories'
import Constants from '@/assets/js/constants'
import MixinGenericComponent from '@/mixins/generic/MixinGenericComponent'
import {usePhonesStore} from '@/stores/PhonesStore'
import {usePhoneTypesStore} from '@/stores/PhoneTypesStore'
import {useMdmStore} from '@/stores/MdmStore'
import MixinGenericJson from "@/mixins/generic/MixinGenericJson";
import {useLoginStore} from "@/stores/LoginStore";
import {eventBus} from "@/main";
import MixinDark from "@/mixins/database/MixinDark";
import {useGeneralStore} from "@/stores/GeneralStore";
import {useAuthenticationStore} from "@/stores/AuthenticationStore";
import {useOptionsStore} from "@/stores/OptionsStore";
import {useCentralisedTemplatesStore} from "@/stores/CentralisedTemplatesStore";
import {useAppUsageRestrictionsStore} from '@/stores/AppUsageRestrictionsStore'
import {useSecurityStore} from "@/stores/SecurityStore";
import {usePersonalControlsStore} from '@/stores/PersonalControlsStore'
import MixinPersonalControl from '@/mixins/MixinPersonalControl'

if (window.location.hostname.indexOf('localhost') !== -1) {

    if (navigator.appVersion.indexOf('Win') != -1) {
        axios.defaults.baseURL = window.location.protocol + '//' + window.location.hostname + '/lightphone/api/'
    } else if (navigator.appVersion.indexOf('Mac') != -1) {
        // axios.defaults.baseURL = window.location.protocol + '//' + window.location.hostname + ':3111/api/'
        axios.defaults.baseURL = window.location.protocol + '//lightphone.dev.com/api/'

    } else if (navigator.appVersion.indexOf('Linux') != -1) {
        // After connecting rpi, the windows laptop also goes here.
        // axios.defaults.baseURL = window.location.protocol + '//' + window.location.hostname + ':3111/api/'
        axios.defaults.baseURL = window.location.protocol + '//lightphone.dev.com/api/'

    }

} else {
    axios.defaults.baseURL = window.location.protocol + '//' + window.location.host + '/api/'
}

export default {
    mixins: [MixinGenericLocalStorage, MixinGenericHelper, MixinConfigCategories, MixinGenericComponent, MixinGenericJson, MixinDark, MixinPersonalControl],
    components: {Snackbar},
    computed: {

        ...mapWritableState(useLoginStore, {
            loginMode: 'loginMode',
        }),

        ...mapWritableState(useGeneralStore, {
            beforeunloadListenerTracker: 'beforeunloadListenerTracker'
        }),
        ...mapWritableState(useAuthenticationStore, {
            isAuthenticated: 'isAuthenticated',
            user: 'user'
        }),

        isHome() {
            return this.$route.name === 'Home'
        },

    },
    methods: {

        /** All methods here should have a prefix of config for code organization purpose. */
        configHasUnsavedChanges() {

            let self = this;

            // If /home is access directly then the listeners would be added when we don't want it to be added. The user would be redirected to the login page but the listener would've already been added by then.
            if (!this.isAuthenticated) {
                return false
            }

            let hasUnsavedChanges = false

            const categoriesStore = useCategoriesStore()
            const groupsStore = useGroupsStore()
            const usersStore = useUsersStore()
            const rulesStore = useRulesStore()
            const connectionsStore = useConnectionsStore()
            const phonesStore = usePhonesStore()
            const optionsStore = useOptionsStore()
            const appUsageRestrictionsStore = useAppUsageRestrictionsStore()
            const securityStore = useSecurityStore();
            const personalControlsStore = usePersonalControlsStore()

            isEqual(usersStore.getUsersInitialState(), usersStore.getUsers()) ? hasUnsavedChanges = false : hasUnsavedChanges = true

            let rulesHasUnSavedChanges = (!hasUnsavedChanges) ? (isEqual(rulesStore.getRulesInitialState(), rulesStore.getRules()) ? hasUnsavedChanges = false : hasUnsavedChanges = true) : false
            let groupsHasUnsavedChanges = (!hasUnsavedChanges) ? (isEqual(groupsStore.getGroupsInitialState(), groupsStore.getGroups()) ? hasUnsavedChanges = false : hasUnsavedChanges = true) : false
            let profilesHasUnsavedChanges = (!hasUnsavedChanges) ? (isEqual(categoriesStore.getProfilesInitialState(), categoriesStore.getProfiles()) ? hasUnsavedChanges = false : hasUnsavedChanges = true) : false
            // let connectionsHasUnsavedChanges = ( ! hasUnsavedChanges) ? (isEqual(connectionsStore.getConnectionsInitialState(), connectionsStore.getConnections()) ? hasUnsavedChanges = false : hasUnsavedChanges = true) : false;
            let whitelistHasUnsavedChanges = (!hasUnsavedChanges) ? (isEqual(categoriesStore.getWhitelistInitialState(), categoriesStore.getWhitelist()) ? hasUnsavedChanges = false : hasUnsavedChanges = true) : false
            let blacklistHasUnsavedChanges = (!hasUnsavedChanges) ? (isEqual(categoriesStore.getBlacklistInitialState(), categoriesStore.getBlacklist()) ? hasUnsavedChanges = false : hasUnsavedChanges = true) : false

            /**
             * Structure of phonesStore.getConfigurationsInitialState() and phonesStore.getConfigurations()
             * [
             {
             key: {String} - Display name or identifier of the phone (e.g. "Priyank's Realme 5 Pro edited")
             value: {
             phone_model: {String} - Model identifier of the phone
             user_group: {String} - Associated user group (empty if unassigned)
             user: {String} - User identifier (if assigned)
             device: {String} - Device name or identifier (optional)

             userInfo: {
             login: {String} - User login email or username
             mdmDeviceId: {String} - Device ID used in MDM context
             password: {String} - MDM user password
             },

             deviceInfo: {
             androidVersion: {String} - OS version
             apiLevel: {Number} - Android API level
             availableRAM: {Number} - Available RAM in bytes
             cpuInfo: {String} - CPU architecture
             deviceBrand: {String} - Brand name (e.g. "realme")
             deviceId: {String} - Unique device ID
             deviceManufacturer: {String} - Manufacturer name
             deviceModel: {String} - Device model name
             deviceProduct: {String} - Product name of the device
             hardware: {String} - Hardware descriptor (e.g. "qcom")
             isEmulator: {Boolean} - Whether device is an emulator
             osName: {String} - OS name (e.g. "Android 11")
             screenDensity: {Number} - Pixel density (dpi scale factor)
             screenHeight: {Number} - Screen height in pixels
             screenWidth: {Number} - Screen width in pixels
             totalRAM: {Number} - Total RAM in bytes
             },

             applications: Array<{ appName: String, packageId: String }>
             - List of known applications (based on your controlled app store or config)

             installed_applications: Array<{ appName: String, packageId: String }>
             - Actual apps found installed on the device (might include unknown or user-installed apps)

             credentials: {
             server: {String} - MDM server address
             account: {String} - Account/username used
             password: {String} - Placeholder or actual password if applicable
             }
             }
             }
             ]
             */
            let phonesHasUnsavedChanges = (!hasUnsavedChanges) ? (isEqual(phonesStore.getConfigurationsInitialState(), phonesStore.getConfigurations()) ? hasUnsavedChanges = false : hasUnsavedChanges = true) : false

            let mdmDeviceIdsWithUnsavedChanges = []
            // Let's track which phone has unsaved changes, we want to track all the mdmDeviceIds, we need to go one level nested deep and track for each phone
            let phonesWithUnsavedChanges = phonesStore.getConfigurations().filter((phone, index) => {

                // Let's compare each phone configuration with its initial state, we compare it's key and value to be exactly as is

                if (isEqual(phone.value, phonesStore.getConfigurationsInitialState()[index].value) && isEqual(phone.key, phonesStore.getConfigurationsInitialState()[index].key)) {
                    return false
                }

                return true

            })

            if (phonesWithUnsavedChanges.length > 0) {
                // Let's track all the mdmDeviceIds with unsaved changes
                phonesWithUnsavedChanges.forEach((phone) => {
                    mdmDeviceIdsWithUnsavedChanges.push(phone.value.userInfo.mdmDeviceId)
                })
            }

            /**
             * Represents a mapping of device identifiers to their respective app usage restriction data.
             *
             * @type {Object.<string, Object>}
             *
             * Example structure:
             * {
             *   "device_id_1": {
             *     rules: [AppUsageRule, AppUsageRule, ...],
             *     appInstallationViaPlayStore: { minutesAllowed: 45, createdAt: "..." }
             *   },
             *   "device_id_2": {
             *     rules: [AppUsageRule, ...],
             *     appInstallationViaPlayStore: null
             *   }
             * }
             *
             * @typedef {Object} AppUsageRule
             * @property {number} id - Unique rule identifier
             * @property {string} ruleName - Human-readable label for the rule
             * @property {'exclusive' | 'quota'} type - Type of rule:
             *           - 'exclusive': app usage allowed only in specific time window
             *           - 'quota': app usage limited by time per day/week
             *
             * @property {Array<AppInfo|string>} apps - List of apps affected by the rule.
             *           - Can be full objects with `appName` and `packageId`, or just package ID strings
             *
             * @property {string} startTime - Start time for app usage (format: 'HH:mm')
             * @property {string} endTime - End time for app usage (format: 'HH:mm')
             *
             * @property {number|null} [allowedTime=null] - Allowed usage time in minutes during the window. `null` means unlimited.
             * @property {number|null} [maxByDay=null] - Maximum allowed time per day in minutes (for 'quota' type)
             * @property {number|null} [maxByWeek=null] - Maximum allowed time per week in minutes (for 'quota' type)
             * @property {Array<number>} [weekDays] - Days of the week rule applies (1=Sunday ... 7=Saturday)
             * @property {boolean|number|null} [strictEnd] - If 1/true, app forcibly closes at `endTime`. Optional.
             *
             * @typedef {Object} AppInfo
             * @property {string} appName - Human-readable app name
             * @property {string} packageId - Unique app package identifier
             */
            let restrictions = appUsageRestrictionsStore.getRestrictions();

            // Now track unsaved changes for the restrictions (an object - not an array) in similar way, add to same array mdmDeviceIdsWithUnsavedChanges
            // Let's track which restriction has unsaved changes, we want to track all the mdmDeviceIds, we need to go one level nested deep and track for each restriction

            for(let deviceId in restrictions) {
                // Let's compare each restriction with its initial state, we compare it's id and value to be exactly as is
                if (isEqual(restrictions[deviceId], appUsageRestrictionsStore.getRestrictionsInitialState()[deviceId])) {
                    continue;
                }
                mdmDeviceIdsWithUnsavedChanges.push(deviceId);
            }

            // Now let's do the same for the security settings as well, we want to track all the mdmDeviceIds

            let securitySettings = securityStore.getSecuritySettings();
            let securitySettingsInitialState = securityStore.getSecuritySettingsInitialState();

            for (let deviceId in securitySettings) {
                // Let's compare each security setting with its initial state, we compare it's id and value to be exactly as is
                if (isEqual(securitySettings[deviceId], securitySettingsInitialState[deviceId])) {
                    continue;
                }
                mdmDeviceIdsWithUnsavedChanges.push(deviceId);
            }

            // Now let's do the same for the personal controls as well, we want to track all the mdmDeviceIds
            let personalControls = personalControlsStore.getPersonalControls();
            let personalControlsInitialState = personalControlsStore.getPersonalControlsInitialState();

            for (let deviceId in personalControls) {
                // Let's compare each personal control setting with its initial state, we compare it's id and value to be exactly as is
                if (isEqual(personalControls[deviceId], personalControlsInitialState[deviceId])) {
                    continue;
                }
                mdmDeviceIdsWithUnsavedChanges.push(deviceId);
            }

            // Let's track mdmDeviceIdsWithUnsavedChanges in a pinia store
            phonesStore.setMdmDeviceIdsWithUnsavedChanges(mdmDeviceIdsWithUnsavedChanges)

            let optionsHasUnsavedChanges = (!hasUnsavedChanges) ? (isEqual(optionsStore.getOptionsInitialState(), optionsStore.getOptions()) ? hasUnsavedChanges = false : hasUnsavedChanges = true) : false
            let appUsageRestrictionsHasUnsavedChanges = (!hasUnsavedChanges) ? (
                isEqual(
                    appUsageRestrictionsStore.getRestrictionsInitialState(),
                    appUsageRestrictionsStore.getRestrictions()
                ) ? hasUnsavedChanges = false : hasUnsavedChanges = true
            ) : false
            let securitySettingsHasUnsavedChanges = (!hasUnsavedChanges) ? (
                isEqual(
                    securityStore.getSecuritySettingsInitialState(),
                    securityStore.getSecuritySettings()
                ) ? hasUnsavedChanges = false : hasUnsavedChanges = true
            ) : false
            let personalControlsHasUnsavedChanges = (!hasUnsavedChanges) ? (
                isEqual(
                    personalControlsStore.getPersonalControlsInitialState(),
                    personalControlsStore.getPersonalControls()
                ) ? hasUnsavedChanges = false : hasUnsavedChanges = true
            ) : false


            /*---------------------------------------------
                Remind user of unsaved changes, when they try to close the tab.
            ----------------------------------------------*/


            //  The trick here is done by the conditional block of event.preventDefault();
            //  Eventhough we have the removeEventListener and even abort, but the condition around event.preventDefault() is actually doing the trick.
            if (self.isHome) {

                let listener = new AbortController();

                let beforeUnloadListener = function (event) {

                    if (self.beforeunloadListenerTracker === 'listening') {
                        event.preventDefault();
                        event.returnValue = ""
                    } else {
                        // This line is optional, ideally if removeListener had worked as intended, this line would not have been there.
                        listener.abort()
                        return;
                    }

                    // return (event.returnValue = "");
                    return;
                };


                let options = {capture: true, signal: listener.signal};


                let delayInterval = 100;
                if (!hasUnsavedChanges) {

                    if (self.beforeunloadListenerTracker === 'listening') {

                        self.beforeunloadListenerTracker = 'notListening'
                        listener.abort()
                        removeEventListener("beforeunload", beforeUnloadListener, options);

                        // To cover for the debounce, and for a quick, on/off/on/off, the add should not be trigerred last due to the debounce delay.
                        setTimeout(() => {
                            removeEventListener("beforeunload", beforeUnloadListener, options);
                        }, delayInterval + 10);

                    }

                } else {

                    if (!self.beforeunloadListenerTracker || self.beforeunloadListenerTracker === 'notListening') {

                        self.beforeunloadListenerTracker = 'listening'

                        // add a debounce here
                        let debounceFn = debounce(function () {
                            addEventListener("beforeunload", beforeUnloadListener, options);
                        }, delayInterval);

                        debounceFn();

                    } else if (self.beforeunloadListenerTracker === 'exitListening') {
                        listener.abort()
                        removeEventListener("beforeunload", beforeUnloadListener, options);
                    }

                }
            } else {

                if (self.beforeunloadListenerTracker === 'listening') {
                    self.beforeunloadListenerTracker = 'exitListening'
                }

            }


            const returnObj = {
                status: hasUnsavedChanges,
                rulesHasUnSavedChanges,
                groupsHasUnsavedChanges,
                profilesHasUnsavedChanges,
                whitelistHasUnsavedChanges,
                blacklistHasUnsavedChanges,
                phonesHasUnsavedChanges,
                optionsHasUnsavedChanges,
                appUsageRestrictionsHasUnsavedChanges,
                securitySettingsHasUnsavedChanges,
                personalControlsHasUnsavedChanges
            }

            return returnObj

        },

        async configLoadAll(connection = false, accountName = false) {

            let params = {}

            if (connection) {
                params = {
                    connection,
                }
            }

            if (accountName) {
                params.accountName = accountName
            }

            return await axios.get('get.php', {params}).then((response) => {
                return response.data
            }).catch((error) => {
                // TODO: Log error
                console.log(error)
                return false
            })
        },

        async configIdefix3Persist(connectionToOverrideDefaultCurrentConnectionSave = false, silently = false, accountName = false) {

            let self = this

            // the unsaved changes should not be persisted if the personal store allowedEdits is false
            // alert only if personalControlsStore.getPersonalControls() is not empty
            let personalControlsStore = usePersonalControlsStore()
            let personalControls = personalControlsStore.getPersonalControls()
            if (Object.keys(personalControls).length > 0 && !personalControlsStore.allowedEdits) {
                self.alertThatSaveIsNotAllowed()
                return false
            }

            const categoriesStore = useCategoriesStore()
            const groupsStore = useGroupsStore()
            const usersStore = useUsersStore()
            const rulesStore = useRulesStore()
            const connectionsStore = useConnectionsStore()
            const progressBarsStore = useProgressBarsStore()
            const idefix3AdditionalFieldsStore = useIdefix3AdditionalFields()
            const phonesStore = usePhonesStore()
            const adminOptionsStore = useAdminOptionsStore()
            const optionsStore = useOptionsStore();
            const appUsageRestrictionsStore = useAppUsageRestrictionsStore()
            const securityStore = useSecurityStore();

            progressBarsStore.setSaveProgressBar(true)

            if (!accountName) {
                accountName = useAuthenticationStore().getUser()?.account
            }

            let params = new FormData()

            if (!connectionToOverrideDefaultCurrentConnectionSave) {
                if (connectionsStore.getCurrentConnection()) {
                    params.append('currentConnection', JSON.stringify(connectionsStore.getCurrentConnection()))
                }
            } else {
                params.append('currentConnection', JSON.stringify(connectionToOverrideDefaultCurrentConnectionSave))
            }

            if (connectionsStore.getConnections()) {
                params.append('connections', JSON.stringify(connectionsStore.getConnections()))
            }

            let version = idefix3AdditionalFieldsStore.getVersion()
            version = isNaN(version) ? false : version

            params.append('rules', JSON.stringify(rulesStore.getRules()))
            params.append('users', JSON.stringify(usersStore.getUsers()))
            params.append('profiles', JSON.stringify(categoriesStore.getProfiles()))
            params.append('whitelist', JSON.stringify(categoriesStore.getWhitelist()))
            params.append('blacklist', JSON.stringify(categoriesStore.getBlacklist()))
            params.append('version', version)
            params.append('ports', JSON.stringify(idefix3AdditionalFieldsStore.getPorts()))
            params.append('portsRules', JSON.stringify(idefix3AdditionalFieldsStore.getPortsRules()))
            params.append('phones', JSON.stringify(phonesStore.getConfigurations()))
            params.append('options', JSON.stringify(optionsStore.getOptions()))
            params.append('accountName', accountName);
            // For adding domain name to a group/dest_domains from the information tab/internet filter/add domain to rule or group
            // Groups tab
            params.append('groups', JSON.stringify(groupsStore.getGroups()))

            // Add app usage restrictions
            params.append('appUsageRestrictions', JSON.stringify(appUsageRestrictionsStore.getRestrictions()))
            params.append('security_settings', JSON.stringify(securityStore.getSecuritySettings()));
            params.append('personalControls', JSON.stringify(personalControlsStore.getPersonalControls()));
            params.append('mdmDeviceIdsWithUnsavedChanges', JSON.stringify(phonesStore.getMdmDeviceIdsWithUnsavedChanges()));

            try {

                const response = await axios.post('save.php', params, {
                    headers: {
                        'Content-Type': 'Application/json',
                    },
                })

                if (response?.data?.status) {

                    let connectionsFromStore = connectionsStore.getConnections()
                    const connectionsFromStoreWithNoReactivity = JSON.parse(JSON.stringify(connectionsFromStore))
                    const profilesFromStoreWithNoReactivity = JSON.parse(JSON.stringify(categoriesStore.getProfiles()))
                    const whitelistFromStoreWithNoReactivity = JSON.parse(JSON.stringify(categoriesStore.getWhitelist()))
                    const blacklistFromStoreWithNoReactivity = JSON.parse(JSON.stringify(categoriesStore.getBlacklist()))

                    if (!silently) {

                        if (self.$refs.snackbar !== undefined) {
                            self.$refs.snackbar.showSnackbar(self.$gettext('Configuration saved.'))
                        } else {

                            let appComponent = self.genericComponentGetComponent('App')
                            appComponent.$refs.snackbar.showSnackbar(self.$gettext('Configuration saved.'))

                        }

                    }

                    usersStore.setUsersInitialState(usersStore.getUsers()) // This is set up differently than profiles or connections, check the store file to know more.
                    rulesStore.setRulesInitialState(rulesStore.getRules()) // This is set up differently than profiles or connections, check the store file to know more.

                    categoriesStore.setProfilesInitialState(profilesFromStoreWithNoReactivity)
                    categoriesStore.setWhitelistInitialState(whitelistFromStoreWithNoReactivity)
                    categoriesStore.setBlacklistInitialState(blacklistFromStoreWithNoReactivity)
                    groupsStore.setGroupsInitialState(groupsStore.getGroups())
                    connectionsStore.setConnectionsInitialState(connectionsFromStoreWithNoReactivity)
                    phonesStore.setConfigurationsInitialState(phonesStore.getConfigurations())
                    phonesStore.setMdmDeviceIdsWithUnsavedChanges([])
                    optionsStore.setOptionsInitialState(optionsStore.getOptions())
                    appUsageRestrictionsStore.setRestrictionsInitialState(appUsageRestrictionsStore.getRestrictions())

                    securityStore.setSecuritySettingsInitialState(
                        JSON.parse(JSON.stringify(securityStore.getSecuritySettings()))
                    );
                    personalControlsStore.setPersonalControlsInitialState(
                        JSON.parse(JSON.stringify(personalControlsStore.getPersonalControls()))
                    );

                } else {

                    if (response.data.hasOwnProperty('error') && response.data.error && response.data.error.length > 0) {
                        self.$refs.snackbar.showSnackbar('Save operation failed. ' + response.data.error, 'error')
                    } else {
                        self.$refs.snackbar.showSnackbar(self.$gettext('Save operation failed.'), 'error')
                    }

                }

                return response.data

            } catch (error) {
                // TODO: Log error
                console.log(error)
            } finally {
                progressBarsStore.setSaveProgressBar(false)
            }

            return false

        },

        /**
         * This is used to track whether the FTP session is currently active.
         * @returns {Promise<any|boolean>}
         */
        async configStatusUpdateConnectionCurrentlyActive() {

            let self = this

            try {

                const response = await axios.get('keep_ftp_session_alive.php', {
                    params: {
                        currentConnection: self.currentConnection,
                    },
                })

                return response.data

            } catch (error) {
                // TODO: Log error
                console.log(error)
            }

            return false

        },

        async configLoadCategories() {

            return await axios.get('get_categories.php').then((response) => {

                if (response.data.status) {
                    return response.data.data.categoriesConfig
                }

            }).catch((error) => {
                // TODO: Log error
                console.log(error)
                return false
            })

        },

        configSetUsersToStore(usersParam, setInitialState = true) {

            let self = this

            const usersStore = useUsersStore()
            const userCategoryLevelCategoryProfileKey = '@_categories_profile';

            for (let userKey in usersParam) {

                let foundProfile = false

                for (let key in usersParam[userKey]) {

                    if (key === userCategoryLevelCategoryProfileKey) {
                        foundProfile = true
                    }

                }

                if (!foundProfile) {

                    usersParam[userKey] = {
                        '@_categories_profile': Constants.defaultProfileName,
                        ...usersParam[userKey],
                    }

                }

            }

            let usersKeyValue = Object.keys(usersParam).map((key) => {

                // We've converted devices and subusers to key value pairs, because we them to be an array containing objects.
                // This was required because we wanted to make those elements draggable and the draggable requires them to be an array.

                return {
                    key,
                    value: Object.keys(usersParam[key]).map((key2) => {

                        if (usersParam[key][key2].hasOwnProperty('subusers') && typeof usersParam[key][key2].subusers === 'object') {
                            usersParam[key][key2].subusers = Object.keys(usersParam[key][key2].subusers).map((key3) => {
                                return {
                                    key: key3,
                                    value: usersParam[key][key2].subusers[key3],
                                }
                            })
                        }
                        if (usersParam[key][key2].hasOwnProperty('devices') && typeof usersParam[key][key2].devices === 'object') {
                            usersParam[key][key2].devices = Object.keys(usersParam[key][key2].devices).map((key3) => {
                                return {
                                    key: key3,
                                    value: usersParam[key][key2].devices[key3],
                                }
                            })
                        }

                        return {
                            key: key2,
                            value: usersParam[key][key2],
                        }
                    }),
                }

            })

            usersStore.setUsers(usersKeyValue)
            if (setInitialState) {
                usersStore.setUsersInitialState(usersKeyValue)
            }

        },

        configSetRulesToStore(rulesParam, setInitialState = true) {

            const rulesStore = useRulesStore()

            let rulesKeyValue = Object.keys(rulesParam).map(key => ({key, value: rulesParam[key],}))

            rulesKeyValue.map((rule) => {

                if (rule.value.dest_domains && typeof rule.value.dest_domains === 'object' && rule.value.dest_domains.length > 0) {
                    rule.value.dest_domains.sort((a, b) => {
                        return a.localeCompare(b, undefined, {sensitivity: 'base'})
                    });
                }

                if (rule.value.dest_groups && typeof rule.value.dest_groups === 'object' && rule.value.dest_groups.length > 0) {
                    rule.value.dest_groups.sort((a, b) => {
                        return a.localeCompare(b, undefined, {sensitivity: 'base'})
                    });
                }

            });

            rulesStore.setRules(rulesKeyValue)
            if (setInitialState) {
                rulesStore.setRulesInitialState(rulesKeyValue)
            }

        },

        configSetOptionsToStore(optionsParam, setInitialState = true) {

            const optionsStore = useOptionsStore()

            if (!optionsParam) {
                return;
            }

            let optionsKeyValue = Object.keys(optionsParam).map(key => ({key, value: optionsParam[key],}))

            optionsStore.setOptions(optionsKeyValue)
            if (setInitialState) {
                optionsStore.setOptionsInitialState(optionsKeyValue)
            }

        },

        configSetConfigurationsToStore(configurationParam, setInitialState = true) {

            // When the phones.json is empty, the configurationParam is an empty string, typeof string.
            let configurationKeyValue = []
            const phonesStore = usePhonesStore()

            if (typeof configurationParam === 'object' && configurationParam.configurations) {
                configurationKeyValue = Object.keys(configurationParam.configurations).map(key => ({
                    key,
                    value: configurationParam.configurations[key],
                }))
            }

            if (configurationKeyValue.length > 0) {
                phonesStore.setConfigurations(configurationKeyValue)
            }

            if (setInitialState) {
                phonesStore.setConfigurationsInitialState(configurationKeyValue)
            }

        },

        configSetPhoneTypesToStore(phoneTypesParam) {

            if (!phoneTypesParam) {
                // TODO: Add a log of development environment only log
                console.info('Phone types are empty');
            }

            // When the phones.json is empty, the configurationParam is an empty string, typeof string.
            let phoneTypesKeyValue = []
            const phoneTypesStore = usePhoneTypesStore()

            if (typeof phoneTypesParam === 'object') {

                phoneTypesKeyValue = Object.keys(phoneTypesParam).map(key => ({
                    key,
                    value: phoneTypesParam[key],
                }))

                if (phoneTypesKeyValue.length > 0) {

                    phoneTypesKeyValue.map((phoneType) => {

                        if (typeof phoneType.value === 'string') {
                            phoneType.value = JSON.parse(phoneType.value)
                        }

                        phoneType.value.applications['all applications'].map((application) => {
                            application.packageId = application['packageId']
                            application.appName = application['appName']
                        })

                    })
                } else {
                    // FIXME: REMOVE THIS | This should be a dev only message.
                    console.info('Phone types are empty');
                }
            }

            phoneTypesStore.setPhoneTypes(phoneTypesKeyValue)

        },

        configSetAppsCommonToStore(commonApplications) {

            const phoneTypesStore = usePhoneTypesStore()
            phoneTypesStore.setAppsCommon(commonApplications)

        },

        configSetGroupsToStore(groups, setInitialState = true) {

            const groupsStore = useGroupsStore()

            // Return early if groups is undefined/null
            if (!groups) {
                groupsStore.setGroups([])
                if (setInitialState) {
                    groupsStore.setGroupsInitialState([])
                }
                return
            }

            let groupsKeyValue = Object.keys(groups).map(key => ({key, value: groups[key]}))

            function buildHierarchy(arr) {

                let root = [];
                let map = {};

                arr.forEach(item => {

                    let parts = item.key.split('/');
                    let currentLevel = root;

                    parts.forEach((part, i) => {

                        if (!map[part]) {
                            let newPart = {
                                'key': part,
                                // ...(i === parts.length - 1 ? {value: item.value} : {child: []}),
                                // The changes from the above line to the following line helps detect the empty folder
                                ...(i === parts.length - 1 ? (item.value ? {value: item.value} : {child: []}) : {child: []}),
                            }

                            map[part] = newPart;
                            currentLevel.push(newPart);
                        }

                        currentLevel = 'child' in map[part] ? map[part].child : [];
                    });

                });

                return root;
            }

            /**
             * The format of groupsKeyValue can be found in groups.md->Data structure of groupsKeyValue
             * @type {*[]}
             */
            groupsKeyValue = buildHierarchy(groupsKeyValue)

            // Sort groupsKeyValue by key where child is present, and then sort alphabetically, further for the els that do not have child, sort alphabetically.
            groupsKeyValue.sort((a, b) => {

                if (a.child && !b.child) {
                    return -1
                } else if (!a.child && b.child) {
                    return 1
                } else if (a.child && b.child) {
                    return a.key.localeCompare(b.key)
                } else {
                    return a.key.localeCompare(b.key)
                }

            });

            // Further the groupsKeyValue would either have a child or not, if the child is present, then we go to child.value.dest_domains and sort that
            // alphabetically. If the child is not present, then we go to value.dest_domains and sort that alphabetically.
            groupsKeyValue.map((group) => {

                if (group.child) {

                    // sort the child by key
                    // TODO: Check if rules are being sorted like this or not.
                    group.child.sort((a, b) => {
                        return a.key.localeCompare(b.key)
                    });

                    group.child.map((child) => {

                        if (Array.isArray(child.value.dest_domains)) {
                            child.value.dest_domains.sort()
                        } else if (typeof group.value.dest_domains === 'string' && group.value.dest_domains.indexOf('\n') !== -1) {
                            group.value.dest_domains = group.value.dest_domains.split('\n');
                            group.value.dest_domains.sort()
                        } else {
                            // FIXME: Remove this
                            console.error('Array was expected for ' + group.value)
                        }

                    });

                } else {

                    if (Array.isArray(group.value.dest_domains)) {
                        group.value.dest_domains.sort()
                    } else if (typeof group.value.dest_domains === 'string' && group.value.dest_domains.indexOf('\n') !== -1) {
                        group.value.dest_domains = group.value.dest_domains.split('\n');
                        group.value.dest_domains.sort()
                    } else {
                        // FIXME: Remove this
                        console.error('Array was expected for ' + group.value)
                    }

                }

            });

            groupsStore.setGroups(groupsKeyValue)

            if (setInitialState) {
                groupsStore.setGroupsInitialState(groupsKeyValue)
            }

        },

        /**
         * Note that setInitialState parameter is not in use because, we are not expecting the version to be changed
         * @param version
         */
        configSetVersionToStore(version) {

            const idefix3AdditionalFieldsStore = useIdefix3AdditionalFields()
            idefix3AdditionalFieldsStore.setVersion(version)

        },

        configSetPortsToStore(ports) {

            const idefix3AdditionalFieldsStore = useIdefix3AdditionalFields()
            idefix3AdditionalFieldsStore.setPorts(ports)

        },
        configSetPortsRulesToStore(portsRules) {

            const idefix3AdditionalFieldsStore = useIdefix3AdditionalFields()
            idefix3AdditionalFieldsStore.setPortsRules(portsRules)

        },
        configSetCategoriesToStore(categories, whitelist, blacklist, setInitialState = true) {

            let categoriesStore = useCategoriesStore()

            let categoriesKeyValue = []

            if (size(categories) > 0) {
                categoriesKeyValue = Object.keys(categories).map(key => ({key, value: categories[key],}))
            }

            categoriesStore.setCategories(categoriesKeyValue)

            categoriesStore.setWhitelist(Object.values(whitelist))
            categoriesStore.setBlacklist(Object.values(blacklist))

            if (setInitialState) {

                categoriesStore.setCategoriesInitialState(JSON.parse(JSON.stringify(categoriesKeyValue)))
                categoriesStore.setWhitelistInitialState(JSON.parse(JSON.stringify(Object.values(whitelist))))
                categoriesStore.setBlacklistInitialState(JSON.parse(JSON.stringify(Object.values(blacklist))))

            }

        },

        /**
         *
         * Please note config is expected to have the following structure:
         * { idefix: { users: {}, rules: {}, categories: {}, whitelist: {}, blacklist: {} }, categories: {} }
         *
         * @param config
         * @param setInitialState
         * @param connection
         * @param source
         * @returns {boolean}
         *
         */
        configSetVariablesToStores(config, setInitialState = true, connection = false, source = 'general') {

            let self = this;

            if (connection) {
                if (connection?.value?.hasOwnProperty('type') && connection?.value?.type?.toLowerCase() === 'ftp' && (!self.loginMode || self.loginMode === 'local')) {
                    this.$vuetify.theme.themes.light.primary = '#377D71';
                } else {
                    setTimeout(() => {
                        this.$vuetify.theme.themes.light.primary = '#214F79';
                    }, 500);
                }
            }

            if (config && typeof config === 'object') {

                let connectionsStore = useConnectionsStore();
                let adminOptionsStore = useAdminOptionsStore();
                let mdmStore = useMdmStore();
                let optionsStore = useOptionsStore();
                let centralisedTemplatesStore = useCentralisedTemplatesStore();
                let appUsageRestrictionsStore = useAppUsageRestrictionsStore()
                let personalControlsStore = usePersonalControlsStore()

                if (!connection) {
                    let filteredConnection = connectionsStore.connections.filter(c => c.key.toLowerCase() === 'local');
                    if (self.genericHelperIsSet(filteredConnection)) {
                        connection = filteredConnection[0];
                    }
                }

                // Validate and parse config.mdm
                if (typeof config.mdm === 'string' && config.mdm !== '') {
                    config.mdm = self.genericJsonValidateAndParse(config.mdm, {
                        source: 'configSetVariablesToStores',
                        key: 'config.mdm'
                    });
                }

                if (config.mdm?.servers?.length > 0) {
                    mdmStore.setServers(config.mdm.servers);
                }

                connectionsStore.isEnabled = (config.settings?.server === '1' || config.settings?.server === 1 || config.settings?.server === true);
                adminOptionsStore.isEnabled = (config.settings?.admin_options === '1' || config.settings?.admin_options === 1 || config.settings?.admin_options === true);

                let configIdefix3, configCategories;

                // Validate and parse config.categories
                if (typeof config.categories === 'string' && config.categories !== '') {
                    config.categories = self.genericJsonValidateAndParse(config.categories, {
                        source: 'configSetVariablesToStores',
                        key: 'config.categories'
                    });
                }

                let profiles = [];
                let whitelist = [];
                let blacklist = [];
                let categoriesStore = useCategoriesStore();

                if (config.categories && config.categories.hasOwnProperty('profiles')) {
                    profiles = config.categories.profiles;
                }

                if (config.categories?.whitelist) {
                    whitelist = config.categories.whitelist;
                }

                if (config.categories?.blacklist) {
                    blacklist = config.categories.blacklist;
                }

                // Ensure profiles categories are an array
                if (profiles && profiles.length === 1 && profiles[0]['profile_name'] === Constants.defaultProfileName) {
                    let categoriesArray = [];
                    if (!Array.isArray(profiles[0]['categories'])) {
                        for (let key in profiles[0]['categories']) {
                            categoriesArray.push(profiles[0]['categories'][key]);
                        }
                        profiles[0]['categories'] = categoriesArray;
                    }
                }

                categoriesStore.setProfiles(profiles);
                categoriesStore.setProfilesInitialState(self.genericJsonValidateAndParse(JSON.stringify(profiles), {
                    source: 'categoriesStore.setProfilesInitialState',
                    key: 'profiles'
                }));

                categoriesStore.setWhitelist(whitelist);
                categoriesStore.setWhitelistInitialState(self.genericJsonValidateAndParse(JSON.stringify(whitelist), {
                    source: 'categoriesStore.setWhitelistInitialState',
                    key: 'whitelist'
                }));

                categoriesStore.setBlacklist(blacklist);
                categoriesStore.setBlacklistInitialState(self.genericJsonValidateAndParse(JSON.stringify(blacklist), {
                    source: 'categoriesStore.setBlacklistInitialState',
                    key: 'blacklist'
                }));

                if (typeof config.idefix3 === 'string' && config.idefix3 !== '') {
                    configIdefix3 = self.genericJsonValidateAndParse(config.idefix3, {
                        source: 'configSetVariablesToStores',
                        key: 'config.idefix3'
                    });
                } else if (typeof config.idefix3 !== 'string') {
                    configIdefix3 = config.idefix3;
                }

                if (typeof config.phones === 'string' && config.phones !== '') {
                    config.phones = self.genericJsonValidateAndParse(config.phones, {
                        source: 'configSetVariablesToStores',
                        key: 'config.phones'
                    });
                }

                if (typeof config.yPhoneTypes === 'string' && config.yPhoneTypes !== '') {
                    config.yPhoneTypes = self.genericJsonValidateAndParse(config.yPhoneTypes, {
                        source: 'configSetVariablesToStores',
                        key: 'config.yPhoneTypes'
                    });
                }

                if (typeof config.appsCommon === 'string' && config.appsCommon !== '') {
                    config.appsCommon = self.genericJsonValidateAndParse(config.appsCommon, {
                        source: 'configSetVariablesToStores',
                        key: 'config.appsCommon'
                    });
                }

                if (typeof config.menuOptions === 'string' && config.menuOptions !== '') {
                    config.menuOptions = self.genericJsonValidateAndParse(config.menuOptions, {
                        source: 'configSetVariablesToStores',
                        key: 'config.menuOptions'
                    });
                }

                if (typeof config.centralisedTemplatesZipNames === 'string' && config.centralisedTemplatesZipNames !== '') {
                    config.centralisedTemplatesZipNames = self.genericJsonValidateAndParse(config.centralisedTemplatesZipNames, {
                        source: 'configSetVariablesToStores',
                        key: 'config.centralisedTemplatesZipNames'
                    });
                }

                if (typeof config.appUsageRestrictions === 'string' && config.appUsageRestrictions !== '') {

                    config.appUsageRestrictions = self.genericJsonValidateAndParse(config.appUsageRestrictions, {
                        source: 'configSetVariablesToStores',
                        key: 'config.appUsageRestrictions'
                    });

                }

                if (typeof config.personalControls === 'string' && config.personalControls !== '') {

                    config.personalControls = self.genericJsonValidateAndParse(config.personalControls, {
                        source: 'configSetVariablesToStores',
                        key: 'config.personalControls'
                    });

                }

                if (configIdefix3) {
                    self.configSetRulesToStore(configIdefix3.rules, setInitialState);
                    self.configSetUsersToStore(configIdefix3.users, setInitialState);
                    self.configSetGroupsToStore(config.phones.groups, setInitialState);
                    self.configSetVersionToStore(configIdefix3.version);
                    self.configSetPortsToStore(configIdefix3.ports);
                    self.configSetPortsRulesToStore(configIdefix3['ports-rules']);
                    self.configSetOptionsToStore(configIdefix3.options, setInitialState);
                }

                self.configSetConfigurationsToStore(config.phones, setInitialState);
                self.configSetPhoneTypesToStore(config.yPhoneTypes);
                self.configSetAppsCommonToStore(config.appsCommon);


                /**
                 * Why this? Because this function is also used by template loader, and templates do not have this, and it becomes blank.
                 */
                if (config.centralisedTemplatesZipNames) {
                    centralisedTemplatesStore.setCentralisedTemplates(config.centralisedTemplatesZipNames);
                }

                if (config.appUsageRestrictions) {
                    appUsageRestrictionsStore.setRestrictions(config.appUsageRestrictions)
                    if (setInitialState) {
                        appUsageRestrictionsStore.setRestrictionsInitialState(config.appUsageRestrictions)
                    }
                }

                if (config.securitySettings) {
                    
                    const securityStore = useSecurityStore();
                    securityStore.setSecuritySettings(config.securitySettings);
                    if (setInitialState) {
                        securityStore.setSecuritySettingsInitialState(
                            JSON.parse(JSON.stringify(config.securitySettings))
                        );
                    }
                } else {
                    // FIXME: Remove this
                    // console.log('No security settings received from backend');
                }

                if (config.personalControls) {
                    const personalControlsStore = usePersonalControlsStore();
                    personalControlsStore.setPersonalControls(config.personalControls);
                    if (setInitialState) {
                        personalControlsStore.setPersonalControlsInitialState(
                            JSON.parse(JSON.stringify(config.personalControls))
                        );
                    }
                    
                    // Use client-side time restriction logic instead of server-side
                    // This provides accurate timezone handling for traveling users
                    // Must be called AFTER setPersonalControls so the store has the data
                    const canEdit = personalControlsStore.isCurrentlyAvailableForEditing(config.personalControls);
                   
                    personalControlsStore.allowedEdits = canEdit;
                    personalControlsStore.startAvailabilityCheck();
                }

                if (config?.hasOwnProperty('isDefaultConfigurationLoadedForCategories') && config.isDefaultConfigurationLoadedForCategories && self.$route.name === 'Home') {
                    self.$nextTick(function () {
                        alertThatWeHaveLoadedDefaultCategoriesConfiguration();
                    });
                }

                function alertThatWeHaveLoadedDefaultCategoriesConfiguration() {
                    let description = '';
                    if (source === 'general') {
                        description = 'The categories module had an issue, we\'ve reset the configuration and the issue is resolved.';
                    } else if (source === 'restore') {
                        description = '<strong>Restore was successful.</strong> However, the categories module had an issue, we\'ve reset the configuration and the issue is resolved. No further action is required.';
                    } else if (source === 'template') {
                        description = 'The categories module had an issue, we\'ve reset the configuration and the issue is resolved.';
                    }
                    self.swalConfirmation({
                        title: 'Whoops!',
                        description: description,
                        icon: 'info',
                        confirmButtonText: source === 'general' ? self.$gettext('Save Now') : 'Save',
                        cancelButtonText: source === 'general' ? self.$gettext('Save Later') : 'Cancel',
                        successCallback: () => {
                            self.configIdefix3Persist();
                        },
                        showCancelButton: true,
                    });
                }
            } else {
                return false;
            }

            return true;
        },

        configDownload() {

            let connectionsStore = useConnectionsStore()

            let params = new FormData()
            params.append('currentConnection', JSON.stringify(connectionsStore.getCurrentConnection()))

            return axios.post('download_configuration_file.php', params, {
                responseType: 'blob',
            })

        },

    },
}
